import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-nowrap text-left" }
const _hoisted_2 = { class: "w-1/2 mr-40" }
const _hoisted_3 = { class: "mb-10" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "w-1/2" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "flex flex-nowrap justify-between" }

import useStore from '@/shared/stores/useStore';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketDeliverableStoreInfo',
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
    id: string;
}




const labels = useBlockLabels();
const store = useStore(props.id);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_unref(store).street), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(store).zipCode) + " " + _toDisplayString(_unref(store).city), 1),
      (_unref(store).phone)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(store).phone), 1))
        : _createCommentVNode("", true),
      (_unref(store).email)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(store).email), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h5", null, _toDisplayString(_unref(labels).clickAndCollectDeliverableStoreInfoOpeningHoursHeading), 1),
      _createElementVNode("dl", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).openingHours, (day) => {
          return (_openBlock(), _createElementBlock("div", {
            key: day.formattedDay,
            class: "w-full flex flex-nowrap justify-between mt-10"
          }, [
            _createElementVNode("dt", null, _toDisplayString(day.formattedDay), 1),
            _createElementVNode("dd", null, _toDisplayString(day.formattedDate), 1),
            _createElementVNode("dd", _hoisted_8, _toDisplayString(day.formattedTime), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})